import Actions from 'reducers/Profile'
import { ProfileService } from 'services'
import { thunks as ReleasesThunks } from 'reducers/Releases'
import type { AppDispatch } from 'types/store'

const getProfile = () => (dispatch: AppDispatch) => {
  ProfileService.getProfile()
    .then((response: any) => {
      dispatch(Actions.didGetProfile(response.data))
    })
    .catch((e: any) => console.warn(e))
}

const postProfile =
  (profile: any, successCallback?: (updatedProfile: any) => void) =>
  (dispatch: AppDispatch) => {
    ProfileService.postProfile(profile)
      .then(() => {
        dispatch(Actions.didUpdateProfileSuccess(profile))
        if (successCallback) {
          successCallback(profile)
        }
      })
      .then(() => {
        // Refresh tokens after profile update
        ReleasesThunks.refreshTokens()
      })
      .catch((e: any) => console.warn(e))
  }

const startMergeEmail = (email: string) => () => {
  return ProfileService.startMergeEmail(email)
}

const postMergeEmailThunks =
  (token: string, successCallBack?: () => void, failureCallBack?: (error: any) => void) =>
  () => {
    return ProfileService.postMergeEmail(token)
      .then(() => {
        if (successCallBack) {
          successCallBack()
        }
      })
      .catch((error: any) => {
        console.error('Error in postMergeEmail thunk error:', error)
        if (failureCallBack) {
          failureCallBack(error)
        }
      })
  }

const startSplitEmail = (email: string) => () => {
  return ProfileService.startSplitEmail(email)
}

const postSplitEmail =
  (token: string, successCallBack?: () => void, failureCallBack?: (error: any) => void) =>
  () => {
    return ProfileService.postSplitEmail(token)
      .then(() => {
        if (successCallBack) {
          successCallBack()
        }
      })
      .catch((error: any) => {
        console.error('Error in postSplitEmail thunk error:', error)
        if (failureCallBack) {
          failureCallBack(error)
        }
      })
  }

export default {
  getProfile,
  postProfile,
  startMergeEmail,
  postMergeEmailThunks,
  startSplitEmail,
  postSplitEmail,
}
